import { render, staticRenderFns } from "./WarningRemoveModal.vue?vue&type=template&id=3a5be93c&"
import script from "./WarningRemoveModal.vue?vue&type=script&lang=js&"
export * from "./WarningRemoveModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5be93c')) {
      api.createRecord('3a5be93c', component.options)
    } else {
      api.reload('3a5be93c', component.options)
    }
    module.hot.accept("./WarningRemoveModal.vue?vue&type=template&id=3a5be93c&", function () {
      api.rerender('3a5be93c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/WarningRemoveModal.vue"
export default component.exports